<nz-modal [(nzVisible)]="isVehicleVisible" [nzTitle]="vehicleTitleContent" [nzWidth]="1054" [nzContent]="vehicleContent"
  [nzFooter]="null" nzCentered [nzClosable]="false">
  <ng-template #vehicleTitleContent>
    <div class="flex-between modal-title">
      <span>{{ "VEHICLE_LINKAGE" | translate }}</span>
      <svg-icon (click)="closeModal()" [iconName]="'close.svg'" [size]="20" class="color-grey cursor-pointer"></svg-icon>
    </div>
  </ng-template>

  <ng-template #vehicleContent>
      <form [formGroup]="searchFormData" class="flex-v-center w-full mt-4">
        <div class="rego_no flex-v-center w-full gap-x-4">
          <nz-select formControlName="brand"  [nzPlaceHolder]="'BRAND' | translate" class="bosch-select w-[20%]" (ngModelChange)="handleChange($event)"  [nzSuffixIcon]="suffixSearch">
            <nz-option *ngFor="let vehicle of vehicles" [nzValue]="vehicle.manuId" [nzLabel]="vehicle.manuName" ></nz-option>
          </nz-select>
          <nz-select formControlName="model"  [nzPlaceHolder]="'MODEL' | translate" class="bosch-select w-[20%]" (ngModelChange)="handleChangeModel()"  [nzSuffixIcon]="suffixSearch">
            <nz-option *ngFor="let model of modelList" [nzValue]="model" [nzLabel]="getFormattedModelLabel(model)" ></nz-option>
          </nz-select>
          <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
        </div>
      </form>
      <div class="result-table w-full">
        <nz-table
        #fixedTable
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
        [nzData]="vehicleData"
        [nzScroll]="{ y: '340px',x:'max-content' }"
        >
        <thead>
          <tr>
            <th nzWidth="300px"> {{ "VEHICLE" | translate }}</th>
            <th nzWidth="100px">{{ "MODELYEAR" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of vehicleData">
            <td>
              <div>{{data.manuDesc}}</div>
              <div>{{data.modelDesc}}</div>
              <div>{{data.carDesc}}</div>
            </td>
            <td> {{data.yearOfConstructionFrom}}</td>
          </tr>
        </tbody>
      </nz-table>
      </div>

  </ng-template>
</nz-modal>
  
